module.exports = __webpack_public_path__ + "static/media/1939fe07993a754364bf3fee5223428d.1939fe07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/1939fe07993a754364bf3fee5223428d.svg
// module id = 994
// module chunks = 17